import { useState, useEffect, useRef, useCallback } from "react";
import api from "../api";
import useAuthStore from "../store/auth";

export default function useNotifications() {
  const { user } = useAuthStore();
  const isFamily = user?.account_type === "family";
  const [notifications, setNotifications] = useState([]);
  const [unread, setUnread] = useState(0);
  const sinceRef = useRef(new Date(Date.now() - 60000).toISOString()); // last 1 min au demarrage
  const intervalRef = useRef(null);

  const fetchNotifications = useCallback(async () => {
    if (!isFamily) return;
    try {
      const { data } = await api.get("/notifications", { params: { since: sinceRef.current } });
      if (data.count > 0) {
        setNotifications(prev => {
          const existingIds = new Set(prev.map(n => n.id));
          const newOnes = data.notifications.filter(n => !existingIds.has(n.id));
          if (newOnes.length > 0) {
            setUnread(u => u + newOnes.length);
            return [...newOnes, ...prev].slice(0, 20);
          }
          return prev;
        });
        sinceRef.current = new Date().toISOString();
      }
    } catch {}
  }, [isFamily]);

  useEffect(() => {
    if (!isFamily) return;
    fetchNotifications();
    intervalRef.current = setInterval(fetchNotifications, 30000);
    return () => clearInterval(intervalRef.current);
  }, [isFamily, fetchNotifications]);

  const markRead = () => setUnread(0);
  const clearAll = () => { setNotifications([]); setUnread(0); };

  return { notifications, unread, markRead, clearAll };
}